import RequestMethod from "../models/client/RequestMethod";
import RestResponse from "../models/client/RestResponse";
import { RestClient } from "./restClient";

export type BlobStorageResponse = {
  uriBase: string;
  sasToken: string;
};

export type BlobStorageServiceType = {
  getTokenedUrl: () => RestResponse<BlobStorageResponse>;
  getWorkspacesAsToken: () => RestResponse<BlobStorageResponse>;
  getWorkspaceStagingSasToken: () => RestResponse<BlobStorageResponse>;
  getWorkspacesAsTokenByTenantId: (
    tenantId: string
  ) => RestResponse<BlobStorageResponse>;
};

const blobStorageServices = (
  client: RestClient,
  path: string
): BlobStorageServiceType => ({
  getTokenedUrl: async () => {
    const response = await client.fetch<BlobStorageResponse>(
      RequestMethod.GET,
      path
    );
    return response;
  },
  getWorkspacesAsToken: async () => {
    const response = await client.fetch<BlobStorageResponse>(
      RequestMethod.GET,
      `${path}/workspaceSasToken`
    );
    return response;
  },
  getWorkspaceStagingSasToken: async () => {
    const response = await client.fetch<BlobStorageResponse>(
      RequestMethod.GET,
      `${path}/workspaceStagingSasToken`
    );
    return response;
  },
  getWorkspacesAsTokenByTenantId: async (tenantId: string) => {
    const response = await client.fetch<BlobStorageResponse>(
      RequestMethod.GET,
      `${path}/workspaceSasToken/${tenantId}`
    );
    return response;
  },
});

export default blobStorageServices;
